import React, { Component } from "react";
import "./header/Header.css"; 
import "../scss/general.css"
import Moment from "moment";
import Mymodal from './modalleave';
//import config from '../config';
import Modal from "react-bootstrap/Modal"
import modallogo from "./images/loader.gif";
import BusyModal from "./modalwait";
import Cookies from "universal-cookie";
import Helmet from 'react-helmet';
import DayPicker, { DateUtils } from "react-day-picker";
import 'react-day-picker/lib/style.css';
import "../scss/radio.scss" ;

const  axios = require("axios");
const cookies = new Cookies();
const columns = [
  {
    field: "name",
    header: "Name",
    width: "200px",
  },
  {
    field: "designation",
    header: "Designation",
    width: "200px",
  },
];

const initialState={
  input:{},
  myitems:[],
  leavedata:{},
  monthstart:0,
  yearstart:0,
  tLeave:0,
  isLoaded: true,
  isData: false,
  fromDate: new Date(),
  toDate: new Date(),
  fdate: Moment(new Date()).format("DD/MM/YYYY"),
  tdate: Moment(new Date()).format("DD/MM/YYYY"),
  fromTime:0,toTime:0,
  from_time:"9:00 AM",to_time:"5:00 PM",
  leaveDays:0,
  options:false,
  AAnnual:0,ASick:0,ACasual:0,ALWP:0,ACMP:0,
  DateED:false,
  edsubmit:true,
  from: undefined,
  to: undefined,
  div1:"none",
  div2:"none",
  selectedDays:[],
  leavetype:"Compensatory",
  toname:"",
  toemail:"",
  error:"",
  errorcss:"labelerror",
  textreason:"",
  disDIV:"none",
  authority:[],
  isOpen:false,
  authorityD:[{"emp_id":"1","name":"CE","designation":"Chief Executive",email:"Khalil.Sattar@KandNs.com"},{"emp_id":"2","name":"ED","designation":"Executive Director",email:"Adil.Sattar@KandNs.com"}],
  ErrMsg:"",
  ErrMsg2:"",
  EmpID:"",
  status:0,
  modifiertext:"",
  getItems:[],
  Myleaves:[],
  myholidays:{holidays:[]},
  myholidaysStyles:{holidays: {color: 'white',backgroundColor: '#ffc107',}},  
  holidaytext:"", 
  divhide:"hidden",
  leavedate:"",
  St:0 

}
class LeaveCompensatory extends Component{
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props){
        super(props);
        this.state=initialState;
//        this.handlechangefrom = this.handlechangefrom.bind(this);
//        this.handlechangeto = this.handlechangeto.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleProceed = this.handleProceed.bind(this);
        this.handleClear = this.handleClear.bind(this);
//        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleDayClick2 = this.handleDayClick2.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.optionG = this.optionG.bind(this);
        this.optionD = this.optionD.bind(this);
        this.ErrHandler = this.ErrHandler.bind(this);
        this.handleLoad=this.handleLoad.bind(this);
        this.handleRadio=this.handleRadio.bind(this);

    }
    handleRadio(e){
      let myleaves=this.state.myholidays;
//      console.log(e.target.value);
      this.setState({againstDate:this.state.Myleaves[e.target.value]["att_date"],div1:""});
     // console.log(Moment(this.state.Myleaves[e.target.value]["att_date"]).format("DD/MM/YYYY"));

 //     console.log(this.state.Myleaves[e.target.value]["att_date"]);
    }


    handleInputChange = (e)=> {
      this.setState({EmpID:e.target.value});
    }
    handleFocus(event){event.target.select();}
  
    ErrHandler(){
      this.setState({...initialState});
      this.componentDidMount();
    } 
    optionG(e){
      this.setState({toname:this.state.authority[e.target.value].name,toemail:this.state.authority[e.target.value].email,edsubmit:false});
    }
    optionD(e){
      this.setState({toname:this.state.authorityD[e.target.value].name,toemail:this.state.authorityD[e.target.value].email,edsubmit:false});
    }
    handleTextChange(e){
      this.setState({textreason:e.target.value});
    }
    handleDayClick2(day) {
//      alert(Moment(day).format("DD/MM/YYYY"));
      const range = DateUtils.addDayToRange(day, this.state);
      this.setState(range);
      let days=0
      days=Math.ceil((day - range.from) / 8.64e7) + 1;
      this.setState({leaveDays:days, disDIV:"none",status:0,fromDate:Moment(day).format("DD/MM/YYYY")});
    }    
    handleDayMouseEnter=(day)=>{
      let newDate=Moment(day).format("DD/MM/YYYY");
      let arrayitem=this.state.getItems;
      this.setState({holidaytext:""});
      let ii=0;
      while(ii < arrayitem.length)
      {
        if(newDate==Moment(arrayitem[ii]["cdate"]).format("DD/MM/YYYY"))
        {
          this.setState({holidaytext:arrayitem[ii]["holidays"]});
        }
        
        ii++;
  
      }
    }
    componentDidMount(){
      this.setState({leavedata:{}});
      axios({
        method: 'get',
        url: cookies.get("phpclass")+'/index.php/user/get_holidays',
        headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
          document.body.style.cursor="default";
          let myholidays=this.state.myholidays;    
          let i=0;
          while(i < response.data.length)
          {
            myholidays.holidays.push(new Date(response.data[i]["cdate"]));
            this.setState({myholidays});
            i++;
          }
          this.setState({getItems:response.data});
        })
        .catch(()=> {
          document.body.style.cursor="default";          
      })      
    }
    handleLoad()
    {
        if(this.state.EmpID.length > 0)
        {
            this.setState({ErrMsg2:<BusyModal/>,Myleaves:[]});
            document.body.style.cursor="wait";
            let input=this.state.input;
            let Myleaves=this.state.Myleaves;
            
            axios.all([
              axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_employee/'+this.state.EmpID,
                headers: {'Content-Type': 'multipart/form-data'}
              }),

              axios({
                    method: 'post',
                    url: cookies.get("phpclass")+'/index.php/user/get_leaveoffdays/'+this.state.EmpID,
                    headers: {'Content-Type': 'multipart/form-data'}
                }),
    
                axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/LeaveAuthority/'+this.state.EmpID,
                headers: {'Content-Type': 'multipart/form-data'}
                })
            ])
            .then(axios.spread((response1,response,response2)=> {
                console.log(response2);
                if(response1.data !== 0 && response.data !== "0")
                {
                  this.setState({authority:response2.data,Myleaves:response.data,divhide:"",myitems:response1.data, ErrMsg:response1.data[0].name +"  ( "+ response1.data[0].desig+" )",ErrMsg2:""});
                  document.body.style.cursor="default";
                }
                else
                {
                    document.body.style.cursor="default";          
                    this.setState({ErrMsg:"No data for compensatory leave found",ErrMsg2:" "});  
                }                  

              }))
            .catch(()=> {
                document.body.style.cursor="default";          
                this.setState({ErrMsg:"No record found",ErrMsg2:" "});
            })
        }
        else
        {
           this.setState({ErrMsg:"Must enter employee ID"});   
        }    
    }    

  /*  handlechangefrom(date)
    {
      this.setState({fdate:Moment(date).format("DD/MM/YYYY"),disDIV:"none"});
    }

    handlechangeto(date)
    {
      this.setState({tdate:Moment(date).format("DD/MM/YYYY"),disDIV:"none"});
      this.setState({toDate:date});
    }
    timeChangeFrom=(event)=>{
      this.setState({fromTime:Number(event.target.value),disDIV:"none",status:0});
    }

    timeChangeTo=(event)=>{
      this.setState({toTime:Number(event.target.value),disDIV:"none",status:0});
    }    
*/

    cur=(num)=> {
    let cnum=parseInt(num,0);
    if(num > 0)
        return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
    }
    handleProceed()
    {
      let from = this.state.from.toString();
      from = from.substring(0,3);

      this.setState({error:""});
      if(this.state.leaveDays > 1)
      {
        this.setState({edsubmit:true,error:"Compensatory leave could be availed for a single day.",errorcss:"labelerror",div2:"none"});
        return;
      }


//      this.setState({edsubmit:true,status:1});
      if(this.state.leaveDays == 0)
      {
        this.setState({error:"Must select leave date",errorcss:"labelerror",div2:"none",edsubmit:true});
        return;
      }
      let days=this.state.leaveDays;
      //let leavedata = this.state.leavedata;
      if((from == "Sat" || from == "Mon" || from == "Sun") && days == 1 )
      {
        this.setState({edsubmit:true,error:"As per policy, you can not avail compensatory leave for Saturday or Monday.",errorcss:"labelerror",leaveDays:0,disDIV:"none",div2:"none"});
        return;
      }
     let ll = 0 
     let sDate=this.state.from;
     const newDate = new Date(sDate.getTime());
     this.setState({selectedDays:[],div2:"",edsubmit:false});
     let selectedDays = this.state.selectedDays;
     while(ll < this.state.leaveDays)
     {
       var adate=newDate.setDate(sDate.getDate() + ll);
       selectedDays.push(new Date(adate));
       ll++;
    }
    this.setState({selectedDays});
    
  }
  handleClear(){
    this.setState({ErrMsg2:""});
    if(this.state.St === 1)
    {
      this.setState({...initialState,leavedata:{}});
    }
  }

  handleSubmit(){
/*    if(this.state.status === 1)
    {*/

      this.setState({ErrMsg2: <BusyModal />});
//      let sdays=this.state.selectedDays; 
//      sdays.sort((a,b) => (a > b) ? 1 : -1)
      let input=this.state.input;
      input["IDM"]=cookies.get("LoginID") ;
      input["empid"]=this.state.EmpID;
      input["days"]=this.state.leaveDays;
      input["againstDate"]=Moment(this.state.againstDate).format("DD/MM/YYYY");
      input["fromDate"]=this.state.fromDate;
      input["toemail"]=this.state.toemail;
      input["toname"]=this.state.toname;
      input["Name"]=this.state.myitems[0]["name"];
      input["desig"]=this.state.myitems[0]["desig"];
      input["location"]=this.state.myitems[0]["location"];

      let tday=this.state.fromDate.toLocaleString("en-us", { day: "2-digit" });
      let tmonth=this.state.fromDate.toLocaleString("en-us", { month: "2-digit" });
      let dd=new Date();
      
      let tyear=dd.getFullYear();

//      alert(this.state.fromDate.getFullYear());
/*      let randomdate=parseInt(tday)+parseInt(tmonth)+parseInt(tyear)+10011;
      input["formid"]=Math.floor(randomdate + Math.random() * 9000);
      alert(Math.floor(randomdate + Math.random() * 9000));
*/

let randomdate=parseInt(tday)+parseInt(tmonth)+parseInt(tyear)+20111;
input["formid"]=Math.floor(randomdate + Math.random() * 9000);
console.log(Math.floor(randomdate + Math.random() * 9000));

//      input["formid"]=Math.floor(100000 + Math.random() * 9000);
      input["leavetype"]="Compensatory";
      this.setState({input});
      document.body.style.cursor="wait";
      console.log(this.state.input);
      axios({
       method: 'post',
       url: cookies.get("phpclass")+'/index.php/user/SubmitCom/',
       data: this.state.input,
       headers: {'Content-Type': 'multipart/form-data'}
     })
     .then((response)=> {
      console.log(response.data);
        document.body.style.cursor="default";
        if(response.data === "2")
        {
          document.body.style.cursor="default";
          this.setState({isOpen:false,St:1,ErrMsg2:<Mymodal Type="0" handler = {this.handleClear} Title="Success" Body="Your request for leave approval sent successfully."/>});
        }         
        else 
        {   
          document.body.style.cursor="default";
//          this.setState({isOpen:false,ErrMsg2:<Mymodal  handler = {this.handleClear} Type="1" Title="Failed" Body="There might be a connection issue. Please try again."/>});
          this.setState({isOpen:false,St:0, ErrMsg2:<Mymodal Type="1" Title="Failed" handler = {this.handleClear} Body="There might be a connection issue. Please try again."/>});
        }
     })
     .catch((response)=> {
        document.body.style.cursor="default";
        this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Transaction is not possible this time, please try after few minutes"/>});
     });
     
/*     
    else
    {
      document.body.style.cursor="default";
      this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Please press the <Proceed> button to update the leave balance."/>});
    }*/
  }

 render(){
  const { from, to } = this.state;
  const modifiers = { start: from, end: to };
  let items=this.state.authority;
  let itemsD=this.state.authorityD;
  let Empitems=this.state.Myleaves;
  
  return (
    <div className="container1">
      <br></br>                             
      <div style={{width:"100%", align:"center",textAlign:"center"}} >
        <br></br>
        <div className="inner-profile">
          <h5>Compensatory Leave Application Form</h5>
{/*}          <form className="col s12">
          <div style={{textAlign:"left"}}>*/}
          <table style={{width:"100%",marginTop:"15px",textAlign:"left"}}>
            <thead></thead>
          <tbody>
          <tr >
              <td style={{width:100}} >
              <input style={{width:100,paddingRight:"0px"}}
                    autoFocus="autofocus"
                    name="EmpID"
                    border="none"
		                placeholder="Employee Id"
                    onChange={this.handleInputChange}
                  />
                </td>
                <td>
                <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={this.handleLoad}>Go </button>                  
              </td>
              <td ></td>
             <td></td>
          </tr>
          <tr>
            <td colSpan={5} style={{textAlign:"left"}}>
            <p style={{paddintTop:0,fontSize:11}}>{this.state.ErrMsg}</p>
            </td>
          </tr>
          </tbody>
        </table >

        <table style={{width:"70%"}} hidden={this.state.divhide}>
            <thead>
                    <tr className="tr" >
{/*}                      <th className="th"></th>*/}
                      <th className="th" scope="col">Date</th>
                      <th className="th" scope="col">Day</th>
                      <th className="th" scope="col">Time in</th>
                      <th className="th" scope="col">Time out</th>
                      <th className="th" scope="col">Total hours</th>
                      <th className="th" scope="col">Event</th>
                   </tr>
            </thead>
            <tbody>
                {Empitems.map((result,i)=>{
                  if(result.thours < 6)
                  {
                    return(
                      <tr className="trc" key={i}>
                        <td className="tdm"><label className="label1"><input disabled type="radio" name="attdate"  value={i} onChange={this.handleRadio}/> {Moment(result.att_date).format("DD/MM/YYYY")}</label></td>
                        <td className="tdm"><label className="label1">{result.dayname}</label></td>
                        <td className="tdm"><label className="label1">{result.timein}</label></td>
                        <td className="tdm"><label className="label1">{result.timeout}</label></td>
                        <td className="tdm"><label className="label1">{result.hours}</label></td>

                        <td className="tdm">{result.holidays}</td>
                      </tr>
                    );
                  }
                  else
                  {
                  return(
                    
                    <tr className="trc" key={i}>
                      <td className="tdm"><label className="label1"><input type="radio" name="attdate"  value={i} onChange={this.handleRadio}/> {Moment(result.att_date).format("DD/MM/YYYY")}</label></td>
                      <td className="tdm"><label className="label1">{result.dayname}</label></td>
                      <td className="tdm"><label className="label1">{result.timein}</label></td>
                      <td className="tdm"><label className="label1">{result.timeout}</label></td>
                      <td className="tdm"><label className="label1">{result.hours}</label></td>
                      <td className="tdm">{result.holidays}</td>
                    </tr>
                  );
                };
              }
              )}
          </tbody>
          </table>
          <div style={{marginTop:"10px",textAlign:"center", marginBotton:"15px",width:"100%", backgroundColor:"black", color:"white",pointerEvents:this.state.div1}}>
              <DayPicker
                disabledDays={{ daysOfWeek: [0] }}
                className="Selectable"
                month = {new Date()}
                fixedWeeks
                numberOfMonths={1} //{this.props.numberOfMonths}
                selectedDays={[from, { from, to }]}
                onDayClick={this.handleDayClick2}
                modifiers={this.state.myholidays}
                modifiersStyles={this.state.myholidaysStyles}
                onDayMouseEnter={this.handleDayMouseEnter}

              />
              <Helmet>
                <style>{`
                .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
                }
                .Selectable .DayPicker-Day {border-radius: 20% !important;}
                .Selectable .DayPicker-Day--start {border-top-left-radius: 20% !important; border-bottom-left-radius: 50% !important;}
                .Selectable .DayPicker-Day--end {border-top-right-radius: 20% !important;border-bottom-right-radius: 50% !important;}
                `}</style>
              </Helmet> 
              <br></br>
            </div>

{/*}            <div style={{marginTop:"10px",marginBotton:"15px",width:"100%", backgroundColor:"black", color:"white",display:this.state.div2}}>
              <DayPicker
                selectedDays={this.state.selectedDays}
                onDayClick={this.handleDayClick}
                month={new Date()}
                fixedWeeks
                numberOfMonths={this.props.numberOfMonths}
                modifiers={this.state.myholidays}
                modifiersStyles={this.state.myholidaysStyles}
                onDayMouseEnter={this.handleDayMouseEnter}
              />
              <Helmet/>
              <table style={{width:"100%"}}>
              <tbody>

                <tr>
                  <td style={{width:"50%",textAlign:"center", padding:"1px" ,color:"white"}}>Leave start time: 
                    <select onChange={this.timeChangeFrom} disabled={this.state.DateED}>
                      <option value="8">9:00 AM</option>
                      <option value="4">1:00 PM</option>
                    </select>                          
                  </td>
                  <td style={{width:"50%",textAlign:"center", padding:"1px" ,color:"white"}}>Leave end time: 
                    <select onChange={this.timeChangeTo} disabled={this.state.DateED}>To
                      <option value="8">5:00 PM</option>
                      <option value="4">1:00 PM</option>
                    </select>                          
                  </td>
                </tr>
                <tr>
                  <td style={{color:"#ffc107",fontWeight:"bold",textAlign:"center",backgroundColor:"black",fontSize:12,height:20 }} colSpan={2}>{this.state.holidaytext}

                  </td>
                </tr>
                </tbody>
              </table>
              <br></br>
            </div>
*/}            
            <div style={{float:"center",marginBotton:"10px",marginTop:"10px",width:"100%",textAlign:"center",pointerEvents:this.state.div1}}>
              <span className={this.state.errorcss} align="left">{this.state.error}</span>
                <button onClick={this.handleProceed} className="btn btn-secondary active" disabled={this.state.DateED}>Proceed</button>
                <br></br>
            </div>
            <table style={{width:"100%", textAlign:"left"}}  >
              <thead >
              </thead>
              <tbody>
                <tr>
                  <td colSpan="4"><b>Approval authority</b></td>
                  <td colSpan="3"><b>for direct reporting</b></td>
              </tr>
              <tr>
                <td colSpan="4" >
                <div style={{width:"100%",height:"150px",textAlign:"left",overflow:"auto",border:"gray solid 1px", float:"left",pointerEvents:this.state.div2}} id="control5">
                  <table style={{width:"100%",marginLeft:"5p"}} >
                  <thead></thead>
                    <tbody>
                      {items.map((result ,i) => {
                       return (
                         <tr className="trc" key={i}>
                           <td style={{width:"95%",paddingLeft:"5px"}}><input  id={result.name} className="radio" type="radio" value={i} name="inputopt" onChange={this.optionG}/><label className="lebel2" htmlFor={result.name}>{result.name}</label></td>
                         </tr>
                       )})}
                    </tbody>
                  </table>
                </div>      

                </td>
                <td colSpan="3">
                  <div style={{width:"100%",height:"150px",textAlign:"left",overflow:"auto",border:"gray solid 1px", float:"righ",pointerEvents:this.state.div2}}>
                    <table style={{width:"100%",marginLeft:"5p"}}>
                      <thead></thead>
                      <tbody>
                        {itemsD.map((resultd ,i) => {
                        return (
                          <tr className="trc" key={i} >
                              <td style={{width:"56%",paddingLeft:"5px"}}><input  id={resultd.name} className="radio" type="radio" value={i} name="inputopt" onChange={this.optionD}/><label className="lebel2" htmlFor={resultd.name}>{resultd.designation}</label></td>

                          </tr>
                        )})}
                      </tbody>                  
                    </table>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <br/>
            <div  style={{width:"100%", paddingTop:"2px", textAlign :"center"}} >
                <button onClick={this.handleSubmit} className="btn btn-secondary active" disabled={this.state.edsubmit}>Submit</button>
                <div style={{width:"5px", height:"auto", display:"inline-block"}}/>
                <button onClick={this.handleClear} className="btn btn-secondary active">Clear</button>
            </div>
          </div>
        </div>      

        {this.state.ErrMsg2}
        <Modal show={this.state.isOpen}  animation="false" centered backdrop="static" size="sm">
        <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
        </Modal>
      </div>
    );
  }
/*}}*/
}
export default LeaveCompensatory;